// src/lib/auth.js
import {
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
} from 'firebase/auth'
import {
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  query,
  where,
} from 'firebase/firestore'
import { auth } from '../firebase'
import { db } from '../firebase'

// --- Récupère le doc utilisateur Firestore à partir du uid ---
async function fetchUserDoc(uid) {
  if (!uid) return null

  // Cas idéal : doc id = uid
  const directRef = doc(db, 'users', uid)
  const directSnap = await getDoc(directRef)
  if (directSnap.exists()) {
    return { id: directSnap.id, ...directSnap.data() }
  }

  // Sinon : on cherche un doc où le champ "uid" == uid
  const q = query(
    collection(db, 'users'),
    where('uid', '==', uid),
    limit(1)
  )
  const snap = await getDocs(q)
  if (!snap.empty) {
    const d = snap.docs[0]
    return { id: d.id, ...d.data() }
  }

  return null
}

// --- Abonnement auth + rôle Firestore + flags admin/vendor ---
export function watchAuth(setter) {
  return onAuthStateChanged(auth, async (u) => {
    if (!u) {
      setter(null)
      return
    }

    // Claims Firebase (custom claims éventuels)
    const token = await u.getIdTokenResult(true)

    let profile = null
    try {
      profile = await fetchUserDoc(u.uid)
    } catch (e) {
      console.warn('Erreur fetch user doc', e)
    }

    // Rôle prioritaire depuis Firestore, sinon depuis les claims
    const roleFromDb = profile?.role
    const roleFromClaims = token.claims.role
    const role = roleFromDb || roleFromClaims || null

    // Normalisation des flags (pratique pour App.js & RequireRole)
    const isAdmin =
      role === 'admin' || token.claims.admin === true
    const isVendor =
      role === 'vendor' || token.claims.vendor === true

    setter({
      user: u,
      claims: {
        ...token.claims,
        role,         // ex: "admin" | "vendor" | null
        admin: isAdmin,
        vendor: isVendor,
      },
      profile,       // doc Firestore complet si besoin
    })
  })
}

export function login(email, password) {
  return signInWithEmailAndPassword(auth, email, password)
}

export function logout() {
  return signOut(auth)
}

// --- Traduction simple des erreurs de login ---
export function translateAuthError(error) {
  const code = error?.code || ''
  switch (code) {
    case 'auth/user-not-found':
      return 'Aucun compte trouvé avec cet email.'
    case 'auth/wrong-password':
      return 'Mot de passe incorrect.'
    case 'auth/invalid-email':
      return 'Adresse email invalide.'
    case 'auth/too-many-requests':
      return 'Trop de tentatives. Réessayez dans quelques instants.'
    case 'auth/network-request-failed':
      return 'Problème de connexion réseau. Vérifiez votre internet.'
    default:
      return error?.message || "Une erreur est survenue lors de la connexion."
  }
}
